/* eslint-disable no-console */

import { register } from 'register-service-worker'

const updateEvent = new Event('content-updated');

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    /* CUSTOM */
    registered( registration ) {
      navigator.serviceWorker.ready.then(registration => {
        registration.sync.register('anm22-sync').then(() => {
          console.log('sync event registered');
        });
      });
    },
    /* DEFAULT */
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      );
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updated () {
      console.log('New content is available; please refresh.')
      window.dispatchEvent(updateEvent);
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
